<app-img [imagePath]="item?.previewImageSrc" [style]="'width: 100%; display: block; max-height: 900px;'"></app-img>